import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    refreshing: Boolean
  }
  static targets = ["overlay"]

  connect() {
    if (this.refreshingValue) this.start()
  }

  disconnect() {
    this.stop()
  }

  show() {
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
  }

  start() {
    this.show()
    this.pollInterval = setInterval(() => this.poll(), 3000)
  }

  stop() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" }
      })
      if (!response.ok) return

      const data = await response.json()
      if (!data.refreshing) {
        this.stop()
        window.Turbo.visit(window.location.href, { action: "replace" })
      }
    } catch (error) {
      console.error("Matching refresh poll failed:", error)
    }
  }
}
